import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNotSureAnsweredQuestions } from './intake.actions';
import { prepareNotSureAnsweredQuestions } from './intake.helpers';
import { selectNotSureAnsweredQuestions } from './intake.selectors';

export const useNotSureAnsweredQuestions = () => {
  const dispatch = useDispatch();
  const notSureAnsweredQuestions = useSelector(selectNotSureAnsweredQuestions);

  return [
    useMemo(() => prepareNotSureAnsweredQuestions(notSureAnsweredQuestions), [notSureAnsweredQuestions]),
    useCallback((value) => {
      dispatch(setNotSureAnsweredQuestions(value));
    }, [dispatch]),
  ];
};
